import ErrorPage from './ErrorPage';

interface ConnectionErrorProps {
  onRetry: () => void;
  relative?: boolean;
}

const ConnectionError: React.FC<ConnectionErrorProps> = ({ onRetry, relative = false }) => (
  <ErrorPage
    title="connectionErrorTitle"
    description="connectionErrorDescription"
    imageSrc={`${process.env.PUBLIC_URL}/assets/images/maintenance.svg`}
    onRetry={onRetry}
    relative={relative}
  />
);

export default ConnectionError;
